var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Users","page-icon":"mdi-account","collection-name":"user","items-per-page":20,"add-dialog-title":"Add User","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }